<template>
  <v-row>
    <v-col cols="12">
      <v-container py-0 v-if="itinerary">
        <v-row align="center">
          <div class="pr-3">
            <reference-label
              v-model="itinerary.reference"
              :itinerary-id="itinerary.id"
            ></reference-label>
          </div>
          <div class="px-3">
            <agent-label
              v-model="itinerary.agentName"
              :agent-id="itinerary.agent.id"
            ></agent-label>
          </div>
          <div class="px-3">
            <client-label
              v-model="itinerary.clientName"
              :client-id="itinerary.client.id"
            ></client-label>
          </div>
          <div class="px-3">
            <span class="button"
              >Itinerary Value:
              <strong
                >{{ itinerary.totalPrice | priceLabeler
                }}{{ itinerary.currencyCode }}</strong
              >
            </span>
          </div>
          <div class="px-3">
            <span class="button"
              >Balance Due:
              <strong
                >{{ itinerary.balance | priceLabeler
                }}{{ itinerary.currencyCode }}</strong
              >
            </span>
          </div>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import ReferenceLabel from "../shared/labels/ReferenceLabel";
import AgentLabel from "../shared/labels/AgentLabel";
import ClientLabel from "../shared/labels/ClientLabel";
export default {
  name: "itinerary-finance-info",

  props: {
    itinerary: {
      type: Object,
      default: () => null,
    },
  },

  components: { ReferenceLabel, AgentLabel, ClientLabel },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/ItineraryDetailsFinanceInfo.vue